import { STAR_URL_NAME } from "@/shared/constants/star"
import { Typography } from "@/components/Typography"
import { useAlertDialog } from "@/shared/context/AlertDialogContext"
import { useAuth } from "@/shared/provider/AuthProvider"
import { useNavigate } from "react-router-dom"

type NewsItemProps = {
  title: string
  date: string
  image: string
  id: number
}

const NewsCard = ({ title, date, image, id }: NewsItemProps) => {
  const { showAlert, closeAlert } = useAlertDialog()
  const { userInfo } = useAuth()
  const navigate = useNavigate()

  const handleNavigate = () => {
    if (userInfo) {
      navigate(`/${STAR_URL_NAME}/news/${id}`)
    } else {
      showAlert({
        logo: false,
        title: "Would you like to log in?",
        actionText: "Log in",
        cancelText: "Cancel",
        onConfirm: () => navigate("/login"),
        onCancel: () => closeAlert(),
      })
    }
  }

  return (
    <div
      role="button"
      className="py-2.5 flex items-center gap-3 cursor-pointer"
      onClick={handleNavigate}
    >
      <div className="h-15 w-18 shrink-0">
        <img
          src={image}
          alt="News Image"
          className="object-cover content-center rounded-xl size-full"
          loading="eager"
        />
      </div>
      <div className="flex flex-col text-start">
        <Typography variant="body-small" className="grow line-clamp-2">
          {title}
        </Typography>
        <Typography variant="body-Xsmall">{date}</Typography>
      </div>
    </div>
  )
}
export default NewsCard
